import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutUs from '../components/AboutUs';

const AboutUsPage = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <AboutUs />
      </main>
      <Footer />
    </div>
  );
};

export default AboutUsPage;

